class ShopDetailsCtrl {
    constructor($scope, $timeout, $stateParams, $sce, $window, storeServ, shopDetailsServ, apiServ, shopTypesServ, $location) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.$sce = $sce;
        this.$window = $window;
        this.storeServ = storeServ;
        this.shopDetailsServ = shopDetailsServ;
        this.apiServ = apiServ;
        this.shopTypesServ = shopTypesServ;
        this.$location = $location;

        this.getShopDetails();

        this.addComponentDestroyListener();
    }

    /**
     *  Init.
     */

    getShopDetails() {
        this.shopDetailsServ.readShopDetails(this.$stateParams.code).then((successResp) => {
            this.shopDetails = Object.assign({}, successResp.data);

            this.offers = successResp.data.offers;

            this.shopHasAppointment = successResp.data.appointment;

            this.setBreadcrumbs();

            this.setDataForTheShopInfoComponent();

            if (this.shopHasAppointment) this.getShopAppointmentInformation();

        }, (errorResp) => {
            this.$window.location.href = this.apiServ.readUrl('error');
        });
    }

    addComponentDestroyListener() {
        this.$scope.$on('$destroy', this.onDestroyComponent.bind(this));
    }


    /**
     *  Listeners.
     */

    onDestroyComponent() {
        this.setShopAppointmentReasons([]);
        this.setShopAppointmentIntervals([]);
    }

    /**
     *  Main methods.
     */

    setBreadcrumbs() {

        this.breadcrumbs = [{
            text: 'home',
            state: 'home',
            params: null
        }, {
            text: this.shopDetails.county,
            state: 'shops-by-district',
            params: {
                district: this.shopDetails.county
            }
        }, {
            text: this.shopDetails.city,
            state: 'shops-by-city',
            params: {
                district: this.shopDetails.county,
                city: this.shopDetails.city
            }
        }, {
            text: this.shopDetails.prettyName,
            state: 'shop-details',
            params: {
                district: this.shopDetails.county,
                city: this.shopDetails.city,
                name: this.shopDetails.shopUrl
            }
        }];
    }

    setDataForTheShopInfoComponent() {
        this.todaysProgram = this.shopDetails.todaysProgram;
        this.directionsUrl = this.shopDetailsServ.getDirectionsUrl(this.shopDetails.latitude, this.shopDetails.longitude);
    }

    getShopAppointmentInformation() {
        this.shopDetailsServ.readShopAppointment(this.$stateParams.code).then(success => {

            this.setShopAppointmentIntervals(success.data.availableAppointments.dateIntervalsList);

            this.setShopAppointmentReasons(success.data.reasons.reasons);
        }, error => {
        });
    }

    setShopAppointmentIntervals(intervals) {
        this.storeServ.dispatch({
            type: 'SET_SHOP_APPOINTMENT_INTERVALS',
            shopAppointmentIntervals: intervals
        });
    }

    setShopAppointmentReasons(reasons) {
        this.storeServ.dispatch({
            type: 'SET_SHOP_APPOINTMENT_REASONS',
            shopAppointmentReasons: reasons
        });
    }
}

ShopDetailsCtrl.$inject = ['$scope', '$timeout', '$stateParams', '$sce', '$window', 'storeServ', 'shopDetailsServ', 'apiServ', 'shopTypesServ', '$location'];

export default ShopDetailsCtrl;
